"use client";

import React from "react";

export type SaveTextFileButtonProps = {
  textData: string; // required text content to save
  filename?: string;
  label?: React.ReactNode;
  className?: string;
  toolTipText?: string;
  disabled?: boolean;
};

export default function SaveTextFileButton({
  textData,
  filename = "data.txt",
  label = "Save as Text File",
  className,
  toolTipText,
  disabled = false,
}: SaveTextFileButtonProps) {
  const handleClick = React.useCallback(() => {
    if (disabled) return;
    try {
      const blob = new Blob([textData ?? ""], {
        type: "text/plain;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "data.txt";
      // For Firefox, the link must be added to the document
      document.body.appendChild(a);
      a.click();
      a.remove();
      // Wait 1 tick to allow download to start, then revoke the data url
      setTimeout(() => URL.revokeObjectURL(url), 0);
    } catch (e) {
      console.error("Failed to save text file:", e);
    }
  }, [textData, filename, disabled]);

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={[
        "px-3 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed",
        className ?? "",
      ].join(" ")}
      aria-label={typeof label === "string" ? label : undefined}
      title={toolTipText}
    >
      {label}
    </button>
  );
}
